// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  root: {
    "borderRadius-kaIpWk": "borderRadius-x12oqio5",
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "gap-kOIVth": "gap-x1jnr06f",
    $$css: "wino-gc:src/resources/feedback-indicators/Badge.res.js:8"
  },
  text: {
    "font-kVVagm": "font-xo1i70s",
    "textAlign-k9WMMc": "textAlign-x2b8uid",
    "whiteSpace-khDVqt": "whiteSpace-xuxw1ft",
    $$css: "wino-gc:src/resources/feedback-indicators/Badge.res.js:14"
  },
  normalTextView: {
    "color-kMwMTN": "color-xhccw90",
    $$css: "wino-gc:src/resources/feedback-indicators/Badge.res.js:19"
  },
  normalView: {
    "backgroundColor-kWkggS": "backgroundColor-x13mx35u",
    $$css: "wino-gc:src/resources/feedback-indicators/Badge.res.js:22"
  },
  informationTextView: {
    "color-kMwMTN": "color-x79xvzw",
    $$css: "wino-gc:src/resources/feedback-indicators/Badge.res.js:25"
  },
  informationView: {
    "backgroundColor-kWkggS": "backgroundColor-xbkk3a2",
    $$css: "wino-gc:src/resources/feedback-indicators/Badge.res.js:28"
  },
  successView: {
    "backgroundColor-kWkggS": "backgroundColor-xp5y61q",
    $$css: "wino-gc:src/resources/feedback-indicators/Badge.res.js:31"
  },
  successTextView: {
    "color-kMwMTN": "color-x1jnb4te",
    $$css: "wino-gc:src/resources/feedback-indicators/Badge.res.js:34"
  },
  dangerView: {
    "backgroundColor-kWkggS": "backgroundColor-x1xxgovl",
    $$css: "wino-gc:src/resources/feedback-indicators/Badge.res.js:37"
  },
  dangerTextView: {
    "color-kMwMTN": "color-x1re7szb",
    $$css: "wino-gc:src/resources/feedback-indicators/Badge.res.js:40"
  },
  primaryView: {
    "backgroundColor-kWkggS": "backgroundColor-xpdwwyo",
    $$css: "wino-gc:src/resources/feedback-indicators/Badge.res.js:43"
  },
  primaryTextView: {
    "color-kMwMTN": "color-x1lewwgq",
    $$css: "wino-gc:src/resources/feedback-indicators/Badge.res.js:46"
  },
  importantView: {
    "backgroundColor-kWkggS": "backgroundColor-x1uaq2c",
    $$css: "wino-gc:src/resources/feedback-indicators/Badge.res.js:49"
  },
  importantTextView: {
    "color-kMwMTN": "color-xufwo1u",
    $$css: "wino-gc:src/resources/feedback-indicators/Badge.res.js:52"
  },
  warningView: {
    "backgroundColor-kWkggS": "backgroundColor-x164ts2d",
    $$css: "wino-gc:src/resources/feedback-indicators/Badge.res.js:55"
  },
  warningTextView: {
    "color-kMwMTN": "color-x1uycxd",
    $$css: "wino-gc:src/resources/feedback-indicators/Badge.res.js:58"
  },
  neutralView: {
    "backgroundColor-kWkggS": "backgroundColor-xcv289a",
    $$css: "wino-gc:src/resources/feedback-indicators/Badge.res.js:61"
  },
  neutralTextView: {
    "color-kMwMTN": "color-x14fu1y",
    $$css: "wino-gc:src/resources/feedback-indicators/Badge.res.js:64"
  },
  highlightedView: {
    "backgroundColor-kWkggS": "backgroundColor-x17suf5r",
    $$css: "wino-gc:src/resources/feedback-indicators/Badge.res.js:67"
  },
  lightText: {
    "color-kMwMTN": "color-xpzg10a",
    $$css: "wino-gc:src/resources/feedback-indicators/Badge.res.js:70"
  },
  darkText: {
    "color-kMwMTN": "color-x10zwbdr",
    $$css: "wino-gc:src/resources/feedback-indicators/Badge.res.js:73"
  }
};
function viewStyleFromParams(variation, highlighted, size, shape, backgroundColor, borderColor) {
  return [highlighted ? styles.highlightedView : variation === "important" ? styles.importantView : variation === "neutral" ? styles.neutralView : variation === "primary" ? styles.primaryView : variation === "warning" ? styles.warningView : variation === "information" ? styles.informationView : variation === "danger" ? styles.dangerView : variation === "normal" ? styles.normalView : variation === "success" ? styles.successView : {}, size === "large" ? {
    height: "24px",
    minHeight: "24px",
    paddingBlock: "4px",
    paddingInline: "6px"
  } : size === "xsmall" || size === "xxsmall" ? {
    borderRadius: "2px",
    height: "12px",
    minHeight: "12px",
    paddingBlock: "2px",
    paddingInline: "2px"
  } : size === "medium" ? {
    height: "22px",
    minHeight: "22px",
    paddingBlock: "4px",
    paddingInline: "6px"
  } : size === "small" ? {
    borderRadius: "2px",
    height: "16px",
    minHeight: "16px",
    paddingBlock: "2px",
    paddingInline: "4px"
  } : size === "normal" ? {
    height: "20px",
    minHeight: "20px",
    paddingBlock: "4px",
    paddingInline: "6px"
  } : {
    height: "28px",
    minHeight: "28px",
    paddingBlock: "4px",
    paddingInline: "10px"
  }, shape === "rounded" ? {} : {
    borderRadius: "999px"
  }, backgroundColor !== undefined ? {
    backgroundColor: backgroundColor
  } : {}, borderColor !== undefined ? {
    borderColor: borderColor,
    borderStyle: "solid",
    borderWidth: "1px"
  } : {}];
}
function textStyleFromParams(variation, highlighted, size, foregroundColor) {
  return [variation === "important" ? styles.importantTextView : variation === "neutral" ? styles.neutralTextView : variation === "primary" ? styles.primaryTextView : variation === "warning" ? styles.warningTextView : variation === "information" ? styles.informationTextView : variation === "danger" ? styles.dangerTextView : variation === "normal" ? styles.normalTextView : variation === "success" ? styles.successTextView : {}, size === "large" ? {
    fontSize: "14px"
  } : size === "xxsmall" ? {
    fontSize: "8px"
  } : size === "small" || size === "xsmall" ? {
    fontSize: "10px"
  } : size === "medium" ? {
    fontSize: "13px",
    fontWeight: 500
  } : size === "normal" ? {
    fontSize: "12px"
  } : {
    fontSize: "16px"
  }, foregroundColor !== undefined ? {
    color: foregroundColor
  } : {}];
}
function shapeFromNext(shape) {
  if (shape === "Rounded") {
    return "rounded";
  } else {
    return "pill";
  }
}
function sizeFromNext(size) {
  switch (size) {
    case "XXS":
      return "xxsmall";
    case "XS":
      return "xsmall";
    case "S":
      return "small";
    case "M":
      return "normal";
    case "L":
      return "medium";
    case "XL":
      return "xlarge";
  }
}
function Badge(props) {
  let __variation = props.variation;
  let __shape = props.shape;
  let __size = props.size;
  let __highlighted = props.highlighted;
  let __endIconSvg = props.endIconSvg;
  let __iconSvg = props.iconSvg;
  let __children = props.children;
  let children = __children !== undefined ? __children : null;
  let iconSvg = __iconSvg !== undefined ? __iconSvg : null;
  let endIconSvg = __endIconSvg !== undefined ? __endIconSvg : null;
  let highlighted = __highlighted !== undefined ? __highlighted : false;
  let size = __size !== undefined ? __size : "large";
  let shape = __shape !== undefined ? __shape : "rounded";
  let variation = __variation !== undefined ? __variation : "normal";
  let newrecord = {
    ...Stylex.props(styles.root, viewStyleFromParams(variation, highlighted, size, shape, props.backgroundColor, props.borderColor))
  };
  let tmp;
  if (children !== null) {
    let newrecord$1 = {
      ...Stylex.props(styles.text, textStyleFromParams(variation, highlighted, size, props.foregroundColor))
    };
    tmp = JsxRuntime.jsx("span", (newrecord$1.children = children, newrecord$1));
  } else {
    tmp = null;
  }
  newrecord.children = [iconSvg, tmp, endIconSvg];
  return JsxRuntime.jsxs("div", newrecord);
}
let make = React.memo(Badge);
export { styles, viewStyleFromParams, textStyleFromParams, shapeFromNext, sizeFromNext, make };
/* styles Not a pure module */